import { nullable, string, struct } from 'io-ts/Decoder';

import { Id as Level } from '../../ai/floor-level/Id';
import { WholeHouseId as WholeHouseAncillaryItemId } from '../../job/ancillary-item';

import { Id as TakeoffId } from './Id';

export const RefItem = struct({
	id: TakeoffId,
	name: string,
	takeoffType: WholeHouseAncillaryItemId,
	level: nullable(Level),
});
